// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__1HJDA","nav":"header_nav__2q-nC"};